<template>
  <div class="form-group row">
    <label class=" col-form-label" :class="labelClass"
      >Email Second Factor</label
    >
    <div class=" input-group " :class="inputClass">
      <input
        type="text"
        placeholder="Enter code here"
        class="form-control border-danger"
        v-model="model.email_auth_code"
      />
      <div class="input-group-append">
        <button
          v-if="!loading_code"
          @click="create2FACode"
          class="btn btn-success"
        >
          Send Code <i class="icon-lock"></i>
        </button>
        <button v-else class="btn btn-success" type="button" disabled>
          <i class="fa fa-spinner fa-spin" />
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.input-group {
  max-height: 2rem;
}
</style>
<script>
import { authMixin } from "@/mixins";

export default {
  props: {
    labelClass: { type: String, default: "col-sm-2" },
    inputClass: { type: String, default: "col-sm-10" },
  },
  name: "email-auth-code",
  mixins: [authMixin],
  watch: {
    "model.email_auth_code": function(newVal) {
      this.$emit("code-changed", newVal);
    },
  },
};
</script>
